import bilAPI from "../api";

export const postPasswordResetForm = (body) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .post(`/auth/password-reset-form/`, body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};
export const postPasswordResetCode = (body) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .post(`/auth/password-reset-confirm/`, body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};
